import gql from 'graphql-tag';

const GET_STORE_BY_TYPE = gql`
    query getJumboStoreByType ($slaType: String) {
        getStoresByType (slaType: $slaType) {
            id,
            title,
            comercial_policy,
            slaType
        }
    }
`;

export default GET_STORE_BY_TYPE;
